var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgInfoOutline = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "currentcolor",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M8 .75a7.25 7.25 0 1 1 0 14.5A7.25 7.25 0 0 1 8 .75zm0 1.611a5.639 5.639 0 1 0 0 11.277A5.639 5.639 0 0 0 8 2.361zM8 7c.414 0 .75.29.75.647v3.455c0 .358-.336.648-.75.648s-.75-.29-.75-.648V7.647C7.25 7.29 7.586 7 8 7zm0-2.75a.75.75 0 1 1 0 1.5.75.75 0 0 1 0-1.5z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgInfoOutline);
export default ForwardRef;